// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_kd-0";
export var optionCard = "_kd-1";